<template>
  <footer class="footer">
    <section class="footer-center">
      <div class="footer-top">
        <div class="footer-ewm">
          <div class="gzh-ewm">
            <img style="width:70px;cursor: pointer; " src="../assets/img/qrcode.png" @click="preview"/>
            <p style="margin-top:5px">关注公众号</p>
          </div>
        </div>
        <div class="footer-gz">
          <div  class="line footer-gzwm">
            <h3>关注我们</h3>
            <p>微信公众号：<span>卖点子 | i51point</span></p>
          </div>
        </div>
      </div>
      <div class="footer_copyright" @click="toBeiAn">Copyright 2018-2019 卖点子 | 51point 版权所有 沪ICP备16052045号-2</div>

    </section>

    <div class="preview" v-if="isPreview" @click="isPreview = false">
      <img src="../assets/img/qrcode_b.jpg" alt="">
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      isPreview: false
    }
  },

  methods: {
    preview() {
      this.isPreview = true;
    },

    toBeiAn() {
      window.open('http://www.beian.miit.gov.cn', '_blank');
    }
  }
}
</script>

<style scoped>

.preview {
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.3);
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview img {
  width: 344px;
  height: 344px;
  -webkit-animation: fadeInDown .3s;
  animation: fadeInDown .3s;
}

.footer-lxwm{
  padding-left: 40px;
}
.footer-gzwm{
  padding-right: 40px;
  /* border-right: 1px solid #E1E1E1; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: 18px;
}
.footer_copyright{
  /* width: 100%; */
  font-size: 12px;
  color: #a9a9a9;
  /* clear: left; */
  margin-top: 12px;
  margin-bottom: 12px;
}
.gzh-ewm{
  font-size: 12px;
  color:#4A4A4A;
  text-align: center;
}
.footer-ewm{
  float: left;
  padding-right: 30px;
  border-right: 1px solid #E1E1E1;
}
.footer-gz{
  padding-left: 30px;
  float: left;
}
.footer-gz h3{
    font-size: 16px;
    color: #333;
    font-weight: normal;
}
.footer-gz p{
    font-size: 13px;
    color: #666666;
    padding: 14px 0 18px 0;
}

.footer{
  height: 140px;
  background: #FFFFFF;
}
.footer-center{
  margin: 0 auto;
  /* width: 606px; */
  padding-top: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
